export const LIST_INSTAGRAM_POSTS = /* GraphQL */ `
  query ListInstagramPostsQuery {
    listInstagramPost {
      id
      follows_count
      followers_count
      media_count
      media {
        data {
          pk
          sk
          caption
          mediaType
          mediaUrl
          thumbnailUrl
          videoUrl
          timestamp
          permalink
        }
      }
    }
  }
`;